import {PERMISSION} from '@/common/constants';
import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {getUserBasicInfo} from '@/api/user';

@Module
export default class UserModule extends VuexModule {
    _userInfo: any = {
        isEditCustomerPriority: false,
        permission: PERMISSION.INITIAL, // 未初始化时
    };

    get userInfo() {
        return this._userInfo;
    }

    @Mutation
    UP_USER_INFO(userInfo: any) {
        this._userInfo = userInfo;
    }

    // https://stackoverflow.com/questions/54127423/vuex-module-decorator-modifying-state-inside-an-action
    @Action({rawError: true})
    async GET_USER_BASIC_INFO({features}: {features: string[]}) {
        const userBasicInfo = await getUserBasicInfo({features});
        const result = userBasicInfo?.data?.result || {};
        const userInfo = {
            ...result,
            features: result.features || [], // 功能白名单
            mobilePhone: result.mobile,
            // isEditCustomerPriority 账户特权，布尔值
            // hasTam 是否是Tam
            // systemAdmin 是否是系统管理员
            // permission原约定无权限是null；现在是null时，后端没有给这个字段，所以这里统一处理为null，以兼容原逻辑
            permission: result.permission || null,
        };
        this.context.commit('UP_USER_INFO', userInfo);
    }
}
